import EditorContextProvider from "../../EditorContextProvider";
import { EditType } from "../../EditorSwiper/EditorSwiper";
import FeatureEdit from "./ReportFeatureEdit";

const EDIT_TYPE = EditType.edit;

const ReportEditor = ({
  setEditableFeature,
  setEditableLayer,
  editableLayer,
  editableFeature,
  config,
  t,
  onClose,
}) => {
  const goBack = () => {
    setEditableFeature(null);
  };

  return (
    <EditorContextProvider
      editType={EDIT_TYPE}
      setEditableFeature={setEditableFeature}
      setEditableLayer={setEditableLayer}
      editableLayer={editableLayer}
      editableFeature={editableFeature}
      isReportsUpdate={true}
    >
      <FeatureEdit config={config} t={t} goBack={goBack} onClose={onClose} />
    </EditorContextProvider>
  );
};

export default ReportEditor;
